(function () {
  'use strict';

  if (window.MBSInstagramFeed) {
    window.MBSInstagramFeed.initAll();
    return;
  }

  var API_ENDPOINT = 'https://minetanbodyskin.com/api/instagram/';
  var REQUEST_TIMEOUT = 10000;
  var requests = {};

  function accountName(value) {
    var account = String(value || 'minetan').toLowerCase();
    if (account === 'bresh') account = 'bfresh';
    return ['minetan', 'btan', 'bfresh'].indexOf(account) !== -1 ? account : 'minetan';
  }

  function safeUrl(value, baseUrl, instagramOnly) {
    try {
      var url = new URL(value, baseUrl);
      if (url.protocol !== 'https:') return null;
      if (
        instagramOnly &&
        url.hostname !== 'instagram.com' &&
        url.hostname !== 'www.instagram.com'
      ) {
        return null;
      }
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function variantsFor(item) {
    if (!item || !Array.isArray(item.images)) return [];

    var apiOrigin = new URL(API_ENDPOINT).origin;
    return item.images
      .map(function (image) {
        var url = image && safeUrl(image.url, API_ENDPOINT, false);
        var width = image && Number(image.width);
        var height = image && Number(image.height);
        if (!url || new URL(url).origin !== apiOrigin || !width || !height) return null;
        return { url: url, width: width, height: height };
      })
      .filter(Boolean)
      .sort(function (left, right) {
        return left.width - right.width;
      });
  }

  function captionFor(item) {
    var caption = typeof item.caption === 'string' ? item.caption.trim() : '';
    return caption ? caption.slice(0, 240) : 'Instagram post';
  }

  function createImage(item, variants) {
    var largest = variants[variants.length - 1];
    var image = document.createElement('img');
    image.src = largest.url;
    image.srcset = variants
      .map(function (variant) {
        return variant.url + ' ' + variant.width + 'w';
      })
      .join(', ');
    image.sizes = '(max-width: 767px) 61vw, (max-width: 1023px) 34vw, 21vw';
    image.width = largest.width;
    image.height = largest.height;
    image.alt = captionFor(item);
    image.loading = 'lazy';
    image.decoding = 'async';
    return image;
  }

  function createLink(item, variants) {
    var permalink = safeUrl(item && item.permalink, API_ENDPOINT, true);
    if (!permalink || variants.length === 0) return null;

    var link = document.createElement('a');
    link.href = permalink;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.aspectRatio = '1 / 1';
    link.setAttribute('aria-label', 'View this post on Instagram');
    link.appendChild(createImage(item, variants));
    return link;
  }

  function createSlide(item, layout) {
    var variants = variantsFor(item);
    var link = createLink(item, variants);
    if (!link) return null;

    if (layout === 'jcarousel') {
      var wrapper = document.createElement('div');
      var figure = document.createElement('figure');
      wrapper.className = 'item';
      figure.appendChild(link.firstChild);
      link.appendChild(figure);
      wrapper.appendChild(link);
      return wrapper;
    }

    if (layout === 'swiper') {
      var swiperSlide = document.createElement('div');
      var background = document.createElement('div');
      var caption = document.createElement('p');
      swiperSlide.className = 'swiper-slide';
      background.className = 'insta__image full-bg';
      background.style.backgroundImage = 'url("' + variants[variants.length - 1].url + '")';
      link.replaceChildren(background);
      caption.textContent = captionFor(item).slice(0, 120);
      swiperSlide.appendChild(link);
      swiperSlide.appendChild(caption);
      return swiperSlide;
    }

    if (layout === 'owl-secondary') link.className = 'hold-img';
    return link;
  }

  function adjustOwlSquares(container) {
    var offset = parseInt(container.getAttribute('data-square-offset') || '0', 10) || 0;
    window.jQuery(container)
      .find('.owl-item')
      .each(function () {
        var item = window.jQuery(this);
        item.css('height', Math.max(1, item.width() - offset) + 'px');
      });
  }

  function initOwl(container, secondary) {
    if (!window.jQuery || typeof window.jQuery.fn.owlCarousel !== 'function') {
      throw new Error('Owl Carousel is not available.');
    }

    var options = secondary
      ? {
          navigation: true,
          pagination: false,
          items: parseInt(container.getAttribute('data-desktop-items') || '3', 10),
          stagePadding: 15,
          itemsTablet: [768, 3],
          itemsTabletSmall: [650, 2],
        }
      : {
          navigation: true,
          items: parseInt(container.getAttribute('data-desktop-items') || '5', 10),
          itemsTablet: [768, 3],
          itemsTabletSmall: [650, 2],
          itemsMobile: [767, 1.65],
        };

    options.afterInit = function () {
      adjustOwlSquares(container);
      window.setTimeout(function () { adjustOwlSquares(container); }, 1500);
      window.setTimeout(function () { adjustOwlSquares(container); }, 3000);
    };

    window.jQuery(container).owlCarousel(options);
    window.addEventListener('resize', function () {
      adjustOwlSquares(container);
    });
  }

  function initJcarousel(container) {
    if (!window.jQuery || typeof window.jQuery.fn.jcarousel !== 'function') {
      throw new Error('jCarousel is not available.');
    }

    var root = container.closest('#insta-slider');
    if (!root) throw new Error('jCarousel root is missing.');

    var carousel = window.jQuery(root).find('.jcarousel');
    var slider = carousel.jcarousel({ wrap: 'both' });

    slider
      .on('jcarousel:reload jcarousel:create', function () {
        var section = window.jQuery(root).closest('.instagram-section');
        var block = window.jQuery(root).closest('.instagram-block');
        var viewWidth = section.length ? section.width() : window.jQuery(window).width();
        var width = block.length ? block.innerWidth() : window.jQuery(root).innerWidth();

        if (viewWidth > 1279) width /= 4;
        else if (viewWidth > 1023) width /= 3;
        else if (viewWidth > 767) width /= 2;
        else width /= 2.5;

        slider.jcarousel('items').css('width', width + 'px');
        slider.jcarousel('items').find('.item').css({
          width: width - 30 + 'px',
          height: width - 22 + 'px',
        });
      })
      .jcarousel();

    window.jQuery(container).on('swipeleft', function () {
      slider.jcarousel('scroll', '+=1');
    });
    window.jQuery(container).on('swiperight', function () {
      slider.jcarousel('scroll', '-=1');
    });
    window.jQuery(root).parent().find('.prev').jcarouselControl({ target: '-=1' });
    window.jQuery(root).parent().find('.next').jcarouselControl({ target: '+=1' });
  }

  function initSwiper(container) {
    if (typeof window.Swiper !== 'function') throw new Error('Swiper is not available.');
    var root = container.closest('.swiper-container');
    if (!root) throw new Error('Swiper root is missing.');

    new window.Swiper(root, {
      slidesPerView: 3,
      autoplay: 3000,
      paginationClickable: true,
      spaceBetween: 30,
      nextButton: '.product--instagram .swiper-button-next',
      prevButton: '.product--instagram .swiper-button-prev',
      breakpoints: {
        400: { slidesPerView: 1, spaceBetween: 10 },
        680: { slidesPerView: 2, spaceBetween: 20 },
        840: { slidesPerView: 3, spaceBetween: 30 },
      },
    });
  }

  function initLayout(container) {
    var layout = container.getAttribute('data-layout') || 'owl-main';
    if (layout === 'jcarousel') initJcarousel(container);
    else if (layout === 'owl-secondary') initOwl(container, true);
    else if (layout === 'swiper') initSwiper(container);
    else initOwl(container, false);
  }

  function requestFeed(account) {
    if (requests[account]) return requests[account];

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller
      ? window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT)
      : null;
    var url = API_ENDPOINT + '?account=' + encodeURIComponent(account);

    requests[account] = window
      .fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Instagram feed returned HTTP ' + response.status + '.');
        return response.json();
      })
      .finally(function () {
        if (timeout !== null) window.clearTimeout(timeout);
      });

    return requests[account];
  }

  function load(container) {
    var state = container.getAttribute('data-instagram-feed-state');
    if (state === 'loading' || state === 'loaded') return;

    container.setAttribute('data-instagram-feed-state', 'loading');
    if (container.getAttribute('data-static') === 'true') {
      try {
        initLayout(container);
        container.setAttribute('data-instagram-feed-state', 'loaded');
      } catch (error) {
        container.setAttribute('data-instagram-feed-state', 'error');
      }
      return;
    }

    var account = accountName(container.getAttribute('data-account'));
    var layout = container.getAttribute('data-layout') || 'owl-main';
    var limit = parseInt(container.getAttribute('data-limit') || '16', 10);
    if (!Number.isFinite(limit) || limit < 1) limit = 16;

    requestFeed(account)
      .then(function (feed) {
        if (!feed || !Array.isArray(feed.items) || feed.items.length === 0) {
          throw new Error('Instagram feed contains no items.');
        }

        var fragment = document.createDocumentFragment();
        feed.items.slice(0, limit).forEach(function (item) {
          var slide = createSlide(item, layout);
          if (slide) fragment.appendChild(slide);
        });
        if (fragment.childNodes.length === 0) throw new Error('Instagram feed has no usable images.');

        container.replaceChildren(fragment);
        initLayout(container);
        container.setAttribute('data-instagram-feed-state', 'loaded');
      })
      .catch(function (error) {
        container.setAttribute('data-instagram-feed-state', 'error');
        if (window.console && typeof window.console.error === 'function') {
          window.console.error('Instagram feed error:', error);
        }
      });
  }

  function initAll(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('[data-instagram-feed]').forEach(load);
  }

  window.MBSInstagramFeed = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
